export const GOOGLE_API_KEY = "AIzaSyCNxuZMsoYo60luivBGsByo4xNhlG0mZNA";
export const GOOGLE_API_KEY = "AIzaSyCNxuZMsoYo60luivBGsByo4xNhlG0mZNA";
